import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

import MainLayout from 'components/templates/main-layout';

import Button from 'components/common/button';
import Input from 'components/common/input';
import Loader from 'components/common/loader';
import SideModal from 'components/common/side-modal';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableHeadCell,
} from 'components/common/table';
import Typography from 'components/common/typography';
import toast from 'components/common/toast';

import { LoaderContainer, HeaderContainer, ModalForm, TableContainer } from './elements';
import { GET_USERS, ADD_USER, UPDATE_USER } from './requests';

class Users extends Component {
  state = {
    users: [],
    user: {},
    showModal: false,
    editUser: false,
    loading: true,
  };

  componentDidMount = () => {
    this.getUsers();
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });

    if (!showModal === false) {
      this.setState({ editUser: false, user: {} });
    }
  };

  getUsers = async () => {
    const { client } = this.props;

    const { data, errors } = await client.query({
      query: GET_USERS,
    });

    if (errors) {
      toast.error('Algo salió mal, intentalo de nuevo');
      this.setState({ loading: false });
      return;
    }

    const { users } = data;

    this.setState({ users, loading: false });
  };

  setUser = user => {
    this.setState({ user, editUser: true });
    this.toggleModal();
  };

  handleInput = e => {
    const { user } = this.state;

    const {
      target: { value, id },
    } = e;

    this.setState({ user: { ...user, [id]: value } });
  };

  handleSubmit = async e => {
    const { user, editUser } = this.state;

    e.preventDefault();

    if (user.password && user.password.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    this.setState({ loading: true });

    let response;

    try {
      response = await (editUser ? this.updateUser({ ...user }) : this.addUser({ ...user }));
    } catch (error) {
      toast.error('Algo salió mal, intentalo cerrando sesíon e iniciando nuevamente');
      this.setState({ error: true, loading: false });
      return;
    }

    const { errors } = response;

    if (errors) {
      toast.error('Algo salió mal, intentalo de nuevo');
      this.setState({ loading: false });
      return;
    }

    await this.getUsers();
    this.toggleModal();
    this.setState({ loading: false });

    const message = editUser ? 'Usuario actualizado' : 'Usuario creado';

    toast.success(`${message} con éxito`);
  };

  addUser = user => {
    const { client } = this.props;

    return client.mutate({
      mutation: ADD_USER,
      variables: { data: user },
    });
  };

  updateUser = user => {
    const { client } = this.props;

    const userId = user.id;
    delete user.id;

    if (user.password && !user.password.length) {
      delete user.password;
    }

    return client.mutate({
      mutation: UPDATE_USER,
      variables: { where: { id: userId }, data: user },
    });
  };

  render() {
    const { users, showModal, editUser, user, loading } = this.state;

    return (
      <MainLayout>
        {loading ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          <Fragment>
            <HeaderContainer>
              <Typography xs>
                En esta sección podrás ver la lista de usuarios, haz click en cualquier fila para
                editar datos de un usuario o crea un usuario en el botón 'Crear usuario'
              </Typography>
              <Button sm onClick={this.toggleModal}>
                Crear nuevo usuario
              </Button>
            </HeaderContainer>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>ID</TableHeadCell>
                    <TableHeadCell>Nombre</TableHeadCell>
                    <TableHeadCell>Email</TableHeadCell>
                    <TableHeadCell>Rol</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map(user => (
                    <TableRow key={user.id} clickable hover onClick={() => this.setUser(user)}>
                      <TableCell>{user.id}</TableCell>
                      <TableCell>{user.name}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.role}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Fragment>
        )}

        {showModal && (
          <SideModal
            active={showModal}
            closeButton={this.toggleModal}
            title={editUser ? 'Editar usuario' : 'Crear usuario'}
          >
            <ModalForm onSubmit={this.handleSubmit}>
              <Input
                input
                type="text"
                id="name"
                label="Nombre"
                value={user.name || ''}
                onChange={this.handleInput}
                required
              />
              <Input
                input
                type="text"
                id="email"
                label="Correo Electrónico"
                value={user.email || ''}
                marginT="10"
                onChange={this.handleInput}
                required
              />
              <Input
                input
                type="password"
                id="password"
                label="Contraseña"
                value={user.password || ''}
                marginT="10"
                onChange={this.handleInput}
                required={!editUser}
              />
              <Input
                select
                type="text"
                id="role"
                label="Rol"
                value={user.role || ''}
                marginT="10"
                onChange={this.handleInput}
                required
              >
                <option value="">Selecciona un rol</option>
                <option value="SUPER_ADMIN">SUPER ADMIN</option>
                <option value="ADMIN">ADMIN</option>
                <option value="COUNTER">CONTADOR</option>
                <option value="AUDITOR">AUDITOR</option>
              </Input>
              {loading ? (
                <Loader alignSelf="flex-end" marginT="20" />
              ) : (
                <Button alignSelf="flex-end" marginT="20">
                  Guardar
                </Button>
              )}
            </ModalForm>
          </SideModal>
        )}
      </MainLayout>
    );
  }
}

Users.propTypes = {
  client: PropTypes.shape().isRequired,
};

export default withApollo(Users);
